<template>
  <div class="home-price-slider-card">
    <div class="px-2">
      <v-card class="transparent" width="100%" height="427" flat tile>
        <!-- Price -->
        <div class="d-flex">
          <h6 class="heading-h6">Loan amount</h6>
          <v-spacer />
          <h6 class="heading-h6">R {{ price }}</h6>
        </div>

        <div class="mt-3">
          <vue-slider
            v-model="price"
            :min="minPrice"
            :max="maxPrice"
            :interval="interval"
            dotSize="20"
            tooltip="none"
          />
        </div>

        <div class="d-flex">
          <p class="b-body-2 gray700--text">R {{ minPrice }}</p>
          <v-spacer />
          <p class="b-body-2 gray700--text">R {{ maxPrice }}</p>
        </div>

        <!-- Days -->
        <div class="d-flex mt-1">
          <h6 class="heading-h6">Loan period</h6>
          <v-spacer />
          <h6 class="heading-h6">{{ formattedLoanPeriod }}</h6>
        </div>

        <div class="mt-3">
          <vue-slider
            v-model="loanPeriodIndex"
            :min="0"
            :max="loanPeriods.length - 1"
            :dot-size="20"
            :tooltip="'none'"
          />
        </div>

        <div class="d-flex">
          <p class="b-body-2 gray700--text">{{ loanPeriods[0] }} days</p>
          <v-spacer />
          <p class="b-body-2 gray700--text">
            {{ loanPeriods[loanPeriods.length - 1] / 30 }} months
          </p>
        </div>

        <!-- Repayable Amount -->
        <div class="d-flex mt-n3">
          <p class="b-body-1">
            Repayable Amount
            <span class="b-body-1 font-weight-bold" style="color: #08338f">
              R {{ amountRepayable }}
            </span>
          </p>

          <!-- img -->
          <v-img
            @click="iconMessage = !iconMessage"
            alt="union"
            class="union pointer mt-n4 ml-2"
            contain
            src="@/assets/img/public/pages/home/mobile/union.svg"
            max-width="14"
          />
        </div>

        <!-- Payday -->
        <div v-if="loanPeriods[loanPeriodIndex] < 60" class="d-flex mt-n3">
          <p class="b-body-1">
            Payday
            <span class="b-body-1 font-weight-bold" style="color: #08338f">
              {{ payday }}
            </span>
          </p>
        </div>

        <v-btn
          :to="{ name: 'RegistrationPage' }"
          class="b-button"
          height="48"
          width="100%"
          elevation="0"
          style="background-color: #08338f; color: white"
        >
          APPLY HERE
        </v-btn>
        <br />
        <br />
        <p class="b-body-2 gray700--text mt-n1">
          Use the loan calculator as reference only. A loan
          <br />
          offer can only be made once we&apos;ve calculated your
          <br />
          affordability.
        </p>
      </v-card>

      <v-bottom-sheet v-model="iconMessage">
        <v-sheet class="px-6 py-3">
          <div class="">
            <p class="b-body-1">
              Interest rate day: 0,16% new clients, 0,1% subsequent
              clients.Initial fee: 16,5% of first R 1 000 lent, 10% of loan
              amount over R 1 000, +VAT.Limited 15% of loan amount, +VAT.
              Service fee R 69 month.
            </p>

            <p class="b-body-1 mt-n1">
              Based on Chapter 5 regulations of NCA no 34 of 2005
            </p>
          </div>

          <v-btn
            @click="iconMessage = !iconMessage"
            class="b-button secondary"
            height="48"
            block
          >
            close
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </div>
</template>

<script>
export default {
  name: "LimeLoansHomepriceslidercard",

  data() {
    return {
      minPrice: 500,
      maxPrice: 8000,
      price: 1700,
      interval: 100,
      loanPeriodIndex: 0,
      loanPeriods: [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        60,
        90,
        120,
        150,
        180, // 2, 3, 4, 5, 6 months (converted to days)
      ],
      minDays: 5,
      maxDays: 90,
      days: 10,
      interest: 24.65,
      amountRepayable: 1246.5,
      payday: "",

      initialFeeAmount: 165,
      serviceFeeFor1stMonth: 6.9,
      serviceFeeFor2ndMonth: 69,

      interestRatePerDay5Percent: 161 / 100000,
      interestRatePerDay3Percent: 1 / 1000,
      interestPerDay: 1.1725,

      iconMessage: false,
    };
  },

  mounted() {
    this.payday = this.moment().add(this.days, "d").format("D MMM YYYY");

    this.setAmountRepayable(this.price, this.days);
  },

  computed: {
    // Calculate the actual days based on loanPeriodIndex
    days() {
      return this.loanPeriods[this.loanPeriodIndex];
    },
    // Format loan period display (days or months)
    formattedLoanPeriod() {
      if (this.days <= 37) {
        return `${this.days} days`;
      } else {
        const months = this.days / 30;
        return `${months} month${months > 1 ? "s" : ""}`;
      }
    },
  },

  watch: {
    price(val) {
      this.setAmountRepayable(val, this.days);
    },

    loanPeriodIndex(val) {
      const actualDays = this.loanPeriods[val];
      this.setAmountRepayable(this.price, actualDays);
      this.payday = this.moment().add(actualDays, "d").format("D MMM YYYY");
    },
  },

  methods: {
    // setAmountRepayable
    setAmountRepayable(price, days) {
      var loanAmount = price; // C2
      var loanPeriod = days; // C3
      var interestRatePercentPerYear = 36 / 100; // C9
      // var interestRatePercentPerMonth = interestRatePercentPerYear / 12; // C10
      var interestRatePercentPerDay = interestRatePercentPerYear / 360; // C11
      var serviceFeePerOneMonth = 69; // C12

      // var serviceFee = this.serviceFeeFor1stMonth;

      var today = this.moment();
      var numberOfDaysInMonth = this.moment(today, "YYYY-MM").daysInMonth(); // 1st month days C15
      var todaysDay = today.format("DD");

      //1st month loan period
      var firstMonthLoanPeriod = numberOfDaysInMonth - todaysDay + 1; // C16
      // var secondMonthLoanPeriod = 0; // C17

      // Loan period: how many month includes
      var numberOfMonths = 1; // C14

      if (numberOfDaysInMonth - todaysDay + 1 < loanPeriod) {
        // serviceFee += this.serviceFeeFor2ndMonth;
        numberOfMonths++;
        // secondMonthLoanPeriod = loanPeriod - firstMonthLoanPeriod; // C17
      }

      // this.interestPerDay = price * this.interestRatePerDay5Percent;

      if (numberOfMonths == 1) {
        firstMonthLoanPeriod = loanPeriod;
      }

      var firstMonthServiceFee =
        (serviceFeePerOneMonth * firstMonthLoanPeriod) / numberOfDaysInMonth; // C19
      var secondMonthServiceFee = 0; // C20

      if (numberOfMonths == 2) {
        secondMonthServiceFee = serviceFeePerOneMonth;
      }

      // =(MIN(IF($C2<1000,165,165+($C2-1000)*0.1),$C2*0.15,1050))*1.15
      var initialFeeAmount = this.initialFeeAmount; // C23

      if (loanAmount >= 1000) {
        // initialFeeAmount = this.initialFeeAmount + loanAmount * 0.1;
        initialFeeAmount = this.initialFeeAmount + (loanAmount - 1000) * 0.1;
      }

      if (initialFeeAmount > loanAmount * 1.15 * 0.15) {
        // initialFeeAmount = loanAmount * 1.15 * 0.15;
        initialFeeAmount = loanAmount * 0.15;
      }

      var initialFeeAmountArray = [
        initialFeeAmount,
        loanAmount * 1.15 * 0.15,
        1050,
      ];

      initialFeeAmount = Math.min(...initialFeeAmountArray) * 1.15;

      var interestPerDay =
        (loanAmount + initialFeeAmount) * interestRatePercentPerDay; //C22

      var interestAmount = interestPerDay * loanPeriod; // C24

      var serviceFeeAmount = firstMonthServiceFee + secondMonthServiceFee; // C25

      // refund = C2 + C23 + C24 + C25
      this.amountRepayable = (
        loanAmount +
        initialFeeAmount +
        interestAmount +
        serviceFeeAmount
      )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");

      this.days = days;

      // console.log("today", today);
      // console.log("todaysDay", todaysDay);
      // console.log("", today.format("DD"));
      // console.log("numberOfDaysInMonth", numberOfDaysInMonth);
      // console.log("numberOfMonths", numberOfMonths);
      // console.log("interestRatePercentPerMonth", interestRatePercentPerMonth);
      // console.log("interestRatePercentPerDay", interestRatePercentPerDay);
      // console.log("serviceFeePerOneMonth", serviceFeePerOneMonth);

      // console.log("firstMonthLoanPeriod", firstMonthLoanPeriod);
      // // console.log("secondMonthLoanPeriod", secondMonthLoanPeriod);
      // console.log("numberOfMonths", numberOfMonths);

      // console.log("firstMonthServiceFee", firstMonthServiceFee);
      // console.log("secondMonthServiceFee", secondMonthServiceFee);

      // console.log("initialFeeAmount", initialFeeAmount);
      // console.log("interestPerDay", interestPerDay);

      // console.log("interestAmount", interestAmount);

      // console.log("serviceFeeAmount", serviceFeeAmount);
    },
  },
};
</script>

<style lang="scss" scoped>
.heading-h6 {
  font-family: "Raleway";
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0px;

  font-style: normal;
}

.b-body-2 {
  font-family: "Noto Sans Display";
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.01em;
}

.icon-card {
  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 8px 6px;

  width: 151px;
  height: 46px;

  /* Neutral/00 */

  background: #ffffff;
  border-radius: 4px;
}

.icon-text {
  //styleName: 12 XS/strike;
  font-family: "Noto Sans Display";
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.01em;
}
</style>
